import FormGroup from '@/ui-kit/components/form/entities/FormGroup';
import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';
import { createLocationFormGroup } from '../../forms/location/controls';
import { createDatePeriodFormGroup } from '../../forms/date-period/controls';
import { BaseFilterForm } from '../enums';

// eslint-disable-next-line import/prefer-default-export
export const createForm = (defaultValue = {}) => new FormGroup({
  [BaseFilterForm.DatePeriod]: createDatePeriodFormGroup(defaultValue[BaseFilterForm.DatePeriod]),
  [BaseFilterForm.Location]: createLocationFormGroup(defaultValue[BaseFilterForm.Location]),
}, [FormControlValidationStrategy.Change]);
